export enum CurrencyType {
  USD = 'USD',
  MMK = 'MMK',
  THB = 'THB',
  VND = 'VND',
  IDR = 'IDR',
  PKR = 'PKR'
}

type T_CurrencyConfig = {
  currency: string
  symbol: string
  symbolFormat: string
}

const CurrencyConfig: Record<string, T_CurrencyConfig> = {
  [CurrencyType.USD]: {
    currency: 'USD',
    symbol: '$',
    symbolFormat: '${0}'
  },
  [CurrencyType.MMK]: {
    currency: 'MMK',
    symbol: 'K',
    symbolFormat: 'K{0}'
  },
  [CurrencyType.THB]: {
    currency: 'THB',
    symbol: '฿',
    symbolFormat: '฿{0}'
  },
  [CurrencyType.VND]: {
    currency: 'VND',
    symbol: '₫',
    symbolFormat: '₫{0}'
  },
  [CurrencyType.IDR]: {
    currency: 'IDR',
    symbol: 'Rp',
    symbolFormat: 'Rp{0}'
  },
  [CurrencyType.PKR]: {
    currency: 'PKR',
    symbol: 'Rs',
    symbolFormat: 'Rs{0}'
  }
}

let _currencyConfig: T_CurrencyConfig

const install = (currency: string) => {
  const key = currency ?? CurrencyType.USD
  let c = CurrencyConfig[key]
  if (!c) {
    c = CurrencyConfig[CurrencyType.USD]
  }
  _currencyConfig = c
}

/**
 * 获取当前货币名称
 * @returns
 */
const getCurrency = () => {
  return _currencyConfig.currency
}

const getCurrencySymbol = () => {
  return _currencyConfig.symbol
}
/**
 * 格式化货币符号
 * @param val
 * @returns
 */
const formatCurrency = (val: string | number) => {
  // console.log()
  return _currencyConfig.symbolFormat.replace('{0}', `${val}`)
}

export const useCurrency = () => ({ install, getCurrency, formatCurrency, getCurrencySymbol })
